import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Card, Link, Typography, Stack, Button, Container, InputAdornment, TextField } from '@mui/material';
import Grid from '@mui/material/Grid'
import { useForm, Controller } from "react-hook-form";
import { showSuccess, showError } from '../../utils/toast';
import { useGetCityQuery, useGetAriaQuery, useGetStateQuery } from '../../redux/services/common/Common';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

// api
import { useGetUpdateSallerAccountApiMutation } from '../../redux/services/seller/seller';



export const AccountUpdate = (props) => {
    const { update, setUpdate, setLoad } = props;
    const [getAccountUpdate, accountUpdate] = useGetUpdateSallerAccountApiMutation()
    // const { data: city } = useGetCityQuery()
    // const { data: aria } = useGetAriaQuery()
    // const { data: state } = useGetStateQuery()

    // console.log("city", city)
    // console.log("aria", aria)



    const { register, handleSubmit, setValue, watch, control, reset, formState: { errors } } = useForm();

    useEffect(() => {

        setValue('first_name', update?.account?.first_name);
        setValue('last_name', update?.account?.last_name);
        setValue('email', update?.account?.email)
        setValue('area', update?.area?.id);
        setValue('mobile', update?.account?.mobile);
        // setValue('state', update?.state?.id);


    }, [update])

    const onSellerAcountUpdate = async (data, event) => {
        event.preventDefault();

        console.log('id', update?.id)
        const body = {
            id: update?.id,
            req: "account",
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            mobile: data.mobile,

        }

        try {
            await getAccountUpdate(body)
            setUpdate(null);
            reset()
            setLoad()

        }
        catch (error) {
            console.log("Error fetching data:", error);

        }
    }

    useEffect(() => {
        if (accountUpdate.isSuccess) {
            showSuccess("Account Updated !", accountUpdate.msg)
            accountUpdate.reset()
        }
        if (accountUpdate.isError) {
            showError(accountUpdate.error.data.msg)
            accountUpdate.reset()

        }
    }, [accountUpdate,])



    return (
        <>
            <Dialog
                open={update != null}
                onClose={() => { setUpdate(null) }}
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography variant='h4' sx={{ textAlign: "center" }}>Seller Account Update</Typography>
                    <hr />
                </DialogTitle>
                <DialogContent>

                    <br />
                    <br />
                    <form id="edit-form" onSubmit={handleSubmit(onSellerAcountUpdate)}>
                        <Container maxWidth="md">
                            <Grid container spacing={1} mb={2}>

                                <Grid item xs={12} sm={6} md={6} mb={2}>
                                    <TextField
                                        label="First_Name"
                                        required
                                        id="outlined-required"
                                        {...register("first_name", { required: 'Enter First_Name' })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} >
                                    <TextField
                                        label="Last_Name"
                                        required
                                        id="outlined-required"
                                        {...register("last_name", { required: 'Enter Last_Name' })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} mb={2} >
                                    <TextField
                                        label="Email"
                                        required
                                        id="outlined-required"
                                        {...register("email", { required: 'Enter Email' })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} >
                                    <TextField
                                        label="Mobile"
                                        required
                                        defaultValue="+91"
                                        id="outlined-required"
                                        {...register("mobile", {
                                            required: 'Enter mobile',
                                            // pattern: {
                                            //     value: /^[0-12]{12}$/, // This enforces exactly 10 digits
                                            //     message: "Mobile number must have exactly 10 digits",
                                            // }
                                        })}
                                        inputProps={{ maxLength: 13, inputMode: "numeric" }}
                                    />

                                </Grid>
                            </Grid>
                        </Container>
                        <DialogActions>
                            <Button type="submit" >
                                Update
                            </Button>
                            <Button onClick={() => { setUpdate(null) }}>Cancel</Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog >
        </>
    );
}




